import queryString from "query-string";
import USER_ROLES_ENUM from "@/utils/enums/userRolesEnum";
import parseObjectToQuery from '@/utils/functions/parseObjectToQuery';
import { setOrdInQuerySearchParams } from "@/utils/functions/setOrdInQuerySearchParams";

export const checkInitialParams = (sortedParam, locationSearch, user) => {
	const {READER} = USER_ROLES_ENUM;
	const firstLoginDefaultDepartment = Boolean(sessionStorage.getItem('firstLoginDefaultDepartment'));
	const firstLoginDefaultVersion = Boolean(sessionStorage.getItem('firstLoginDefaultVersion'));
	const sortedParamQueryString = queryString.parse(sortedParam ? setOrdInQuerySearchParams(sortedParam) : '');
	let initialQueryString =  { ...queryString.parse(locationSearch)};

	if(firstLoginDefaultDepartment && user?.departments[0]?.id) {
		initialQueryString = { ...initialQueryString, department: user?.departments[0]?.id };
	}
	if (firstLoginDefaultVersion && !initialQueryString?.version && user.role === READER?.name) initialQueryString = {...initialQueryString, version: 'final'};

	if(!firstLoginDefaultDepartment) delete initialQueryString.department;
	if(!firstLoginDefaultVersion) delete initialQueryString.version;

	if(sortedParam) {
		delete initialQueryString.category;
		delete initialQueryString.ownerId;
		delete initialQueryString.q;
		delete initialQueryString.recipient;
	}

	return `${parseObjectToQuery({...initialQueryString, ...sortedParamQueryString})}`;
};
